import { Input, Label } from "reactstrap";
import { handleFormChange } from "../../../components/modals/EditableTable";
import { useTranslation } from "react-i18next";
import InfoTip from "../../../components/InfoTip";

const ZoneSettingsAdministrator = ({ formData, setFormData }) => {
  const { t } = useTranslation();

  const options = [
    {
      name: "activatedSortingErrorOption",
      labelKey: t("Enable the sorting errors option"),
      tip: t("Enable the sorting errors option"),
    },
    {
      name: "activatedFillingLevelOption",
      labelKey: t("Show filling level"),
      tip: `${t(
        "Hide the filling level of the container throughout the client application",
      )}.`,
    },
    {
      name: "characterization",
      labelKey: t("Enable the characterizations option"),
    },
    {
      name: "qualicheck",
      labelKey: t("enableQualicheckOption"),
    },
    {
      name: "showDepotCycle",
      labelKey: t("Use depot cycle"),
      tip: `${t(
        "Show a depot cycle with the first image in the history view and showing the images first to last",
      )}
              .`,
    },
  ];

  return (
    <div className="flex flex-col w-full">
      {options.map((opt) => (
        <div key={opt.name} className="zone-settings__checkbox-row">
          <div className="zone-settings__checkbox-wrap">
            <Input
              type="checkbox"
              id={opt.name}
              name={opt.name}
              checked={!!(formData[opt.name] ?? false)}
              onChange={(e) => handleFormChange(e, formData, setFormData)}
              className="zone-settings__checkbox"
            />
          </div>
          <div className="flex-1 min-w-0 flex items-center gap-1.5">
            <Label
              htmlFor={opt.name}
              className="zone-settings__checkbox-label mb-0 ml-3"
            >
              {t(opt.labelKey)}
            </Label>
            {opt?.tip && <InfoTip nudgeY={1}>{opt.tip}</InfoTip>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ZoneSettingsAdministrator;
